// Shared by pages/LandingPage.jsx (featured products) and
// pages/CatalogBrowsePage.jsx (category browse) — both render the same kind
// of price-free product card and both build the same shape of request line
// from a clicked product, so this lives in one place rather than twice.

import { RAW_DESCRIPTION_MAX } from '../schemas/requestLineSchema.js';

// catalog.condition.* keys are camelCase (e.g. refurbished_manufacturer ->
// refurbishedManufacturer) — same transform admin/src/pages/CatalogPage.jsx
// already uses for the exact same ENUM, reused rather than re-invented.
export function conditionLabelId(condition) {
  return `catalog.condition.${condition.replace(/_([a-z])/g, (_, c) => c.toUpperCase())}`;
}

export function productDisplayName(product, lang) {
  return lang === 'am' && product.name_am ? product.name_am : product.name;
}

// The line a catalog pick pre-fills — "Request price", the in-form catalog
// search (Entry Point 1), and the browse-page pending list (Entry Point 2)
// all build a line through this one function. qty/rawDescription stay fully
// editable once the buyer reaches the request-lines form; editing
// rawDescription does NOT clear matchedProductId — the product link and
// the buyer's own current wording are two separate pieces of information,
// same as request_lines.matched_product_id/raw_description already are for
// an Excel-matched line.
//
// productName/productSpec are carried along for RequestLinesForm's own
// catalog-line rendering (name + spec beneath, distinct from a typed line)
// — display-only, a snapshot taken at pick time rather than a live re-fetch,
// and never sent to the backend (routes/requestRoutes.js's lineSchema only
// accepts rawDescription/rawUnit/qty/matchedProductId).
export function buildLineFromProduct(product, lang) {
  const name = productDisplayName(product, lang);
  const spec = product.display_description || '';
  const rawDescription = (spec ? `${name} — ${spec}` : name).slice(0, RAW_DESCRIPTION_MAX);
  return {
    rawDescription,
    rawUnit: product.unit || '',
    qty: '1',
    matchedProductId: product.id,
    productName: name,
    productSpec: spec,
  };
}
